export default "__VITE_ASSET__56c33af3__"